export const normalizeLongitude360 = (longitude: number) => {
    return ((longitude % 360) + 360) % 360;
};

export const normalizeLongitude180 = (longitude: number) => {
    return (((longitude % 360) + 540) % 360) - 180;
};
